"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const capabilities = [{
  eyebrow: "01 / NEW CONSTRUCTION",
  title: "Custom home design",
  description: "Tailored residential architecture that balances modern aesthetics with functional living. From initial site analysis to final construction documents, we create homes that reflect your unique vision.",
  stack: ["Modern", "Contemporary", "Custom"],
  href: "/HomePage"
}, {
  eyebrow: "02 / INVESTMENT",
  title: "Investment properties",
  description: "Strategic design solutions for developers and investors. We maximize square footage and curb appeal to ensure your property stands out in the competitive Knoxville market.",
  stack: ["Efficiency", "ROI", "Market-Ready"],
  href: "/HomePage"
}, {
  eyebrow: "03 / CHALLENGING LOTS",
  title: "Difficult site solutions",
  description: "Expertise in navigating steep slopes, narrow footprints, and irregular lots. We turn site constraints into architectural opportunities with creative, permit-ready engineering.",
  stack: ["Steep-Slope", "Narrow", "Infill"],
  href: "/HomePage"
}];
export default function Services() {
  return <section data-section-id="14458" id="design-specializations" className="bg-background py-24 md:py-32 font-default">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8 pt-24 md:pt-32">

        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div data-scroll-item className="lg:col-span-7">
            <h2 className="font-default font-bold text-foreground leading-[0.96] tracking-tight text-[clamp(2.25rem,4.6vw,4.25rem)]">
              What I <span className="italic font-bold">design</span>.
            </h2>
          </div>
          <div data-scroll-item className="lg:col-span-5 lg:self-end">
            <p className="text-foreground/80 font-default text-[clamp(1.0625rem,1.15vw,1.25rem)] leading-[1.55] tracking-[-0.005em]">
              Professional architectural services focused on contemporary residential projects, investment properties, and complex site development in Knoxville.
            </p>
          </div>
        </div>

        {/* Capability cards */}
        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 border-2 border-foreground">
          {capabilities.map((cap, i) => <article key={cap.eyebrow} data-scroll-item data-index={i} className={`group relative bg-background hover:bg-secondary p-10 md:p-12 flex flex-col transition-all duration-200 ease-[cubic-bezier(0.2,0.8,0.2,1)] hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-[6px_6px_0_0_var(--foreground)] ${i > 0 ? "border-t-2 md:border-t-0 md:border-l-2 border-foreground" : ""}`}>
              <div className="font-mono text-foreground/70 text-xs font-semibold tracking-[0.14em] uppercase leading-none">
                {cap.eyebrow}
              </div>

              <h3 className="mt-6 font-default font-semibold text-foreground text-[clamp(1.5rem,2.2vw,2rem)] leading-[1.05] tracking-tight">
                {cap.title}
              </h3>

              <div className="mt-6 h-[2px] w-full bg-foreground" aria-hidden="true" />

              <p className="mt-6 text-foreground/80 font-default text-base leading-[1.6]">
                {cap.description}
              </p>

              <div className="mt-8 flex flex-wrap gap-2">
                {cap.stack.map((tech, j) => <span key={tech} data-index={j} className="inline-flex items-center border-[1.5px] border-foreground px-3 py-1 font-mono text-xs font-medium text-foreground">
                    {tech}
                  </span>)}
              </div>

              <div className="mt-10 pt-2">
                <Link to={cap.href} className="inline-flex items-center gap-2 text-foreground font-default font-medium text-sm group/link">
                  <span className="relative pb-1 border-b-2 border-primary group-hover/link:border-[3px] transition-all duration-200">
                    View details
                  </span>
                  <ArrowRight className="size-4 transition-transform duration-200 ease-out group-hover/link:translate-x-1" strokeWidth={1.75} />
                </Link>
              </div>
            </article>)}
        </div>

      </div>
    </section>;
}